import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'util-overlay',
  template: `<div class="overlay {{type}}">
  <div class="overlay-body" [ngSwitch]="type">
    <div *ngSwitchCase="'loading'">
      <div class="overlay-icon">
        <cui-loader [label]="message" color="muted"></cui-loader>
        <!-- <cui-spinner></cui-spinner> -->
      </div>
      <!--
      <div class="overlay-message">
        <span>{{message || 'Loading...'}}</span>
      </div>
    -->
    </div>
    <div *ngSwitchCase="'error'">
      <h4 class="overlay-message">{{message || 'ERROR'}}</h4>
    </div>
    <div *ngSwitchCaseDefault>
      DEFAULT
    </div>
  </div>
</div>
`,
  styles: [`.overlay{display:block;position:absolute;left:0;top:0;right:0;bottom:0;background-color:#f2f2f2;opacity:.8;z-index:2}.overlay.error{background-color:#cf2030;color:#fff;opacity:1}.overlay>.overlay-body{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center}.overlay>.overlay-body .overlay-icon{margin-bottom:.5rem}`]
})
export class OverlayComponent {
  @Input() type: string;
  @Input() message: string;

  constructor() { }

}
